export default "__VITE_ASSET__CZQsT7HK__"